/* eslint-disable */
import { produce } from "immer";
import {
  CALCULATE_POT_FETCH_FAILURE,
  CALCULATE_POT_FETCH_SUCCESS,
  CALCULATE_POT_FETCH_START,
  CALCULATE_POT_FETCH_MODAL_SUCCESS,
} from "../actions/types";

const calculateEstimatedPot = (
  state = {
    calculatePotFetching: false,
    calculatePotData: {},
    calculatePotDataForModal: {},
    calculatePotError: null,
  },
  action,
) => {
  switch (action.type) {
    case CALCULATE_POT_FETCH_START:
      return produce(state, (draft) => {
        draft.calculatePotFetching = true;
      });
    case CALCULATE_POT_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.calculatePotFetching = true;
        draft.calculatePotData = action.data;
        draft.calculatePotFetching = false;
      });
    case CALCULATE_POT_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.calculatePotFetching = false;
        draft.calculatePotError = action.error;
      });
    case CALCULATE_POT_FETCH_MODAL_SUCCESS:
      return produce(state, (draft) => {
        draft.calculatePotFetching = true;
        draft.calculatePotDataForModal = action.data;
        draft.calculatePotFetching = false;
      });
    default:
      return state;
  }
};

export default calculateEstimatedPot;
